import { OutlinedTextFieldProps, TextField } from '@mui/material';
import React from 'react';
import { UseWatchProps, Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import HookFormHelper from '~/helpers/HookFormHelper';

interface IOutlinedInputWithControllerProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  name: string;
  hookFormProps?: Omit<UseWatchProps<any>, 'name' | 'render'>;
  hideErrorMessage?: boolean;
  absoluteHelperText?: boolean;
}

/**
 * TextField (variant="outlined") с react-hook-form Controller
 * @param name - для react-hook-form Controller
 * @param hookFormProps
 * @param rest - наследуются от OutlinedTextFieldProps
 */
export const OutlinedInputWithController: React.FC<IOutlinedInputWithControllerProps> = (props) => {
  const { name, hookFormProps, hideErrorMessage, absoluteHelperText, FormHelperTextProps, ...rest } = props;

  const { t } = useTranslation();

  const { classes, cx } = useStyles();

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => {
        const errorMessage = HookFormHelper.getI18nHookFormErrorMessage(fieldState.error?.message, t);

        return (
          <TextField
            inputRef={field.ref}
            variant="outlined"
            {...rest}
            {...field}
            error={!!errorMessage || props.error}
            helperText={!hideErrorMessage && (errorMessage || props.helperText)}
            ref={null}
            FormHelperTextProps={{
              ...FormHelperTextProps,
              className: cx(classes.errorMessage, { absoluteHelperText }, ...(FormHelperTextProps?.className ?? '')),
            }}
          />
        );
      }}
      {...hookFormProps}
      control={hookFormProps?.control || control}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  errorMessage: {
    '&.absoluteHelperText': {
      position: 'absolute',
      top: 40,
      margin: '0 4px',
      width: '100%',
      textWrapMode: 'wrap',
      zIndex: theme.zIndex.appBar - 1,
    },
  },
}));
